module.exports = __webpack_public_path__ + "img/03—01—01—Combined—WLAN.919dc3ff.jpg";